export const SET_SERVER_ERROR = "SET_SERVER_ERROR";
export const SET_BUILDER_STATUS = "SET_BUILDER_STATUS";
export const SET_SETTINGS_SUBMENU_STATUS = "SET_SETTINGS_SUBMENU_STATUS";
export const CHANGE_ITEMS_PER_PAGE = "CHANGE_ITEMS_PER_PAGE";
export const SET_CURRENT_SEQUENCE_PAGE = "SET_CURRENT_SEQUENCE_PAGE";
